import { FORM_FIELD_TYPE } from 'enums';

export const defineFieldType = fieldType => ({
  isSelect: fieldType === FORM_FIELD_TYPE.select,
  isDate: fieldType === FORM_FIELD_TYPE.date,
  isDecimal: fieldType === FORM_FIELD_TYPE.decimal,
  isInput: fieldType === FORM_FIELD_TYPE.input,
});
